import { sendEvent } from '@utils/core/track';
import Modal from 'ac-components/modal';
import classnames from 'classnames';
import Anchor from 'containers/ac-containers/ac-anchor';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import { useModalContext } from 'hooks/useModalContext';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import List from '../faq/components/list/main';
import { TeamSection, FeatureSection, TagsSection, PartnersSection, DescriptionSection, FaqsSection } from './components';
import styles from './styles.scss';

export default function TutorsPage(props: { location: any }) {
	const { width } = useResizeObserver();
	const showModal = localStorage.getItem('showModal') === 'true';
	const [isShow, setTrigger] = useState<boolean>(false);
	const anchor = useHistory().location.hash;
	const { transData, t } = useTranslation('home');
	const list = t('partner.modal.list') as unknown as any[];
	useEffect(() => {
		if (!anchor) {
			window.scrollTo(0, 0);
		}
	}, []);

	useEffect(() => {
		if (!showModal) {
			setTrigger(true);
		}
	}, []);

	useEffect(() => {
		list[0].question = t('partner.modal.list[0].question', { size: width < 768 ? 16 : 20 });
	}, [width]);

	const onChange = (data: any, index: number) => {
		// eslint-disable-next-line default-case
		switch (index) {
			case 2:
				sendEvent({ eventId: 'partner_click_school' });
				break;
			case 3:
				sendEvent({ eventId: 'partner_click_employer' });
				break;
			case 4:
				sendEvent({ eventId: 'partner_click_influencer' });
				break;
		}
	};

	return (
		<div className={styles['ac-container']}>
			<main className={styles['ac-partner']}>
				<DescriptionSection id="description" />
				<PartnersSection />
				<TagsSection />
				<TeamSection />
				<FeatureSection />
				<FaqsSection />
				<Anchor className={styles.anchor} anchorText={'description'}>
					<img src={transData.toTop} alt="" />
				</Anchor>
			</main>
			<Modal
				show={false}
				onClose={() => {
					setTrigger(!isShow);
					localStorage.setItem('showModal', 'true');
				}}
				className={classnames(styles['ac-modal'])}>
				<div className={styles['ac-modal-wrap']}>
					<div className={styles['ac-modal-head']}>{t('partner.modal.title')}</div>
					<div className={styles['ac-modal-body']}>
						<List listData={list} isPosition transData={transData} isHtml slideDown={false} onChange={onChange} />
					</div>
				</div>
			</Modal>
		</div>
	);
}
